// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.step-hint-bar.m16{\n  margin-bottom: 16px!important;\n}\n", ""]);
// Exports
module.exports = exports;
